import distributorIcon from "@src/assets/svg/distributor-icon.svg";
import factoryIcon from "@src/assets/svg/factory-icon.svg";
import oemIcon from "@src/assets/svg/oem-icon.svg";
import supIcon from "@src/assets/svg/sup-icon.svg";
import { useI18N } from "@src/language/language-context";
import {
  CrossNameSpaceOrganziation,
  OrganizationTableRow,
  OrganizationType,
} from "@src/types/namespace-configuration";

const typeIcons: Record<Exclude<OrganizationType, "other">, string> = {
  support: supIcon,
  OEM: oemIcon,
  distributor: distributorIcon,
  factory: factoryIcon,
};

export const useOrganizationsTableAdminPanelHook = (
  organizations: CrossNameSpaceOrganziation[],
) => {
  const i18n = useI18N();
  const texts = {
    typeHeader: i18n("modules.organizationsTableAdminPanel.typeHeader"),
    nameHeader: i18n("modules.organizationsTableAdminPanel.nameHeader"),
    noOrganizations: i18n(
      "modules.organizationsTableAdminPanel.noOrganizations",
    ),
    otherOrganizationType: i18n(
      "modules.organizationsTableAdminPanel.otherOrganizationType",
    ),
  };

  const organizationRows: OrganizationTableRow[] = organizations.map(
    (organization, index) => ({
      key:
        organization.id || `${organization.type}-${organization.name}-${index}`,
      type: organization.type,
      typeIcon:
        organization.type === "other"
          ? undefined
          : typeIcons[organization.type],
      dataType: organization.type,
      name: organization.name || "—",
    }),
  );

  return {
    organizationRows,
    texts,
  };
};
